<template>
	<div class="notIndex guide">
        <main>
            <div class="blueBg blueBg3 content">
                <div class="innerImage">
                    <h2>
                        {{ $t('guide.titleLabel') }}
                    </h2>
                    <div class="lead">{{ $t('guide.leadLabel') }}</div>
                    <div class="stepBox">
                        <div class="content">
                            <div class="row row01">
                                <div class="image wow fadeInUp">
                                    <img src="./assets/images/img_guide01.png" alt="" class="pc">
                                    <img src="./assets/images/img_guide01_sp.png" alt="" class="sp">
                                </div>
                                <div class="textContent wow fadeInUp">
                                    <h3>{{ $t('guide.sections[0].titleLabel') }}</h3>
                                    <p v-html="$t('guide.sections[0].content')"></p>
                                </div>
                            </div>
                            <div class="row row02">
                                <div class="image wow fadeInUp">
                                    <img src="./assets/images/img_guide03.png" alt="" class="pc">
                                    <img src="./assets/images/img_guide03_sp.png" alt="" class="sp">
                                </div>
                                <div class="textContent wow fadeInUp">
                                    <h3>{{ $t('guide.sections[1].titleLabel') }}</h3>
                                    <p v-html="$t('guide.sections[1].content')"></p>
                                </div>
                            </div>
                            <div class="row row03">
                                <div class="image wow fadeInUp">
                                    <img src="./assets/images/img_guide02.png" alt="" class="pc">
                                    <img src="./assets/images/img_guide02_sp.png" alt="" class="sp">
                                </div>
                                <div class="textContent wow fadeInUp">
                                    <h3>{{ $t('guide.sections[2].titleLabel') }}</h3>
                                    <p v-html="$t('guide.sections[2].content')"></p>
                                    <div class="button">
                                        <router-link :to="{ name: 'video' }">
                                            <button class="btn">{{ $t('guide.contentsListBtn') }}</button>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
	</div>
</template>

<script>
    export default {

        components: {
        },

        data() {
            return {
            }
        },

        mounted() {

            this.$nextTick(function () {
                // javascript追加
                var scripts = ['/assets/js/jquery-3.4.1.min.js', '/assets/js/modernizr.min.js', '/assets/js/slick.min.js', '/assets/js/wow.min.js', '/assets/js/common.js'];
                var len = scripts.length;
                var i = 0;

                (function appendScript() {
                    if (scripts[i] != undefined){
                        var script = document.createElement('script');
                        script.src = scripts[i];
                        document.body.appendChild(script);

                        if (i++ < len) {
                            script.onload = appendScript;
                        }
                    }
                })();
            });
        },

        methods: {
        }
    }
</script>

<style scoped>
</style>
